const colors = {
  primary: '#000000',      // Black for header
  accent: '#FFF000',       // Yellow accent color
  drawer: '#121212',       // Dark gray for drawer
  text: {
    primary: '#FFFFFF',    // White text for dark backgrounds
    secondary: '#CCCCCC',  // Light gray for secondary text
    accent: '#000000',     // Black text for accent backgrounds
  },
  background: '#FFFFFF',   // White background for content areas
  border: '#333333',       // Dark gray for borders
  success: '#4CAF50',      // Keep some utility colors
  error: '#FF5252',
  warning: '#FFC107',
  destructive: '#F44336',
};

export default colors;

